import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DeleteModal from '../../utils/deleteModal/deleteModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import AddUser from './AddUser';
import services from '../../services';
import { GET_ALL_USER } from '../../utils/Apifunction';
import { FiEdit } from 'react-icons/fi';
import { MdDeleteOutline, MdAdd, MdChevronLeft, MdChevronRight } from 'react-icons/md';
import Select from "react-select";
import './User.css';

const UserTable = () => {
    const [userData, setUserData] = useState([]);
    const [editData, setEditData] = useState('');
    const [editId, setEditId] = useState('');
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [selectDeleteId, setSelectDeleteId] = useState('');
    const [addUserStatus, setAddUserStatus] = useState(false);
    const [searchUserData, setSearchUserData] = useState('');
    const [sortProducts, setSortProducts] = useState({ key: 'createdAt', direction: 'desc' });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;
    const [gmailUsers, setGmailUsers] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const navigate = useNavigate();

    const handleStatusToggle = async (item) => {
        try {
            await services.user.UPDATE_USER(item?.id, { status: !item?.status });
            toast.success(`${item?.name}'s status updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update status!');
            console.error(e);
        }
    };

    const handleEdit = (data) => {
        setEditData(data);
        setAddUserStatus(true);
        setEditId(data?.id);
    };

    const handleDelete = async () => {
        try {
            await services.user.DELETE_USER(selectDeleteId);
            toast.success('User deleted successfully!');
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to delete user!');
            console.error(e);
        }
    };
    const getAllLinkedEmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            if (response) {
                const options = response?.data?.map((email) => ({
                    label: email.email,
                    value: email.id,
                    color: email.colour,
                }));
                setGmailUsers(options);
            }
        } catch (error) {
            console.error('error');
        }
    };
    const handleConfirm = () => {
        setShowModalDelete(false);
        handleDelete();
    };

    useEffect(() => {
        GET_ALL_USER_DATA();
        getAllLinkedEmail()

    }, [searchUserData, sortProducts, currentPage]);

    const GET_ALL_USER_DATA = async () => {
        const object = {
            page: currentPage,
            search: searchUserData,
            sortBy: sortProducts.key,
            sortOrder: sortProducts.direction,
            pageSize: pageSize,
            isPermission: true,
        };
        const response = await GET_ALL_USER(object);
        if (response) {
            setUserData(response?.users || []);
            setTotalPages(response?.totalPages || 1);
        }
    };

    function handleSort(key) {
        setSortProducts((prev) => {
            if (prev.key === key) {
                return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            return { key, direction: 'asc' };
        });
        setCurrentPage(1);
    }
    function renderSortIcon(key) {
        if (sortProducts.key !== key) return null;
        return sortProducts.direction === 'asc' ? ' ▲' : ' ▼';
    }
    const [selectedEmailsByUser, setSelectedEmailsByUser] = useState({});
    const handleArchivePermission = async (item) => {
        try {
            await services.user.UPDATE_USER(item?.id, { isPermission: !item?.isPermission });
            toast.success(`${item?.name}'s archive permission updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update archive permission!');
            console.error(e);
        }
    };

    const handleAssingUser = async (userId, selectedEmails) => {
        try {
            await services.user.UPDATE_USER(userId, {
                usersEmailMapped: selectedEmails ?? []
            });

            toast.success(`Archive permissions updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update archive permission!');
            console.error(e);
        }
    };
    const handleEmailChange = (userId, selected) => {
        setSelectedEmailsByUser(prev => ({
            ...prev,
            [userId]: selected || []
        }));

        handleAssingUser(userId, selected)
    };
    useEffect(() => {
        if (Array.isArray(userData)) {
            const mapped = {};
            userData.forEach(user => {
                mapped[user.id] = user.usersEmailMapped || [];
            });
            setSelectedEmailsByUser(mapped);
        }
    }, [userData]);

    return (
        <div className="px-5 py-2">

            <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
                <button className="btn btn-outline-primary" onClick={() => navigate('/app')}>
                    Back
                </button>
                <h1 className="text-center text-2xl font-bold text-blue-500" >User Management</h1>
                <input
                    type="text"
                    placeholder="Search by name or email..."
                    value={searchUserData}
                    onChange={(e) => {
                        setSearchUserData(e.target.value);
                        setCurrentPage(1);
                    }}
                    className="min-w-[220px] px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-200"
                />
            </div>
            <div className="overflow-y-auto max-h-[80vh] overflow-x-auto rounded-xl border border-gray-200 mt-4">
                <table className="min-w-full bg-white">
                    <thead>
                        <tr>
                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('no')}
                            >
                                No.
                            </th>
                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('name')}
                            >
                                User Name
                            </th>
                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('email')}
                            >
                                Email
                            </th>
                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('createdAt')}
                            >
                                Create Date
                            </th>

                            <th
                                className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50 cursor-pointer"
                                onClick={() => handleSort('userEmailMapped')}
                            >
                                Assign Email Inbox
                            </th>
                            <th className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50">Actions</th>
                            <th className="sticky top-0 z-10 px-4 py-2 text-left font-semibold text-blue-600 bg-blue-50">
                                Archive Permission
                            </th>
                        </tr>
                    </thead>
                    <tbody className="table-body">
                        {userData.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center text-gray-400 py-8">
                                    No users found.
                                </td>
                            </tr>
                        ) : (
                            userData.map((item, index) => (

                                <tr key={item.id} className="hover:bg-blue-50 transition">
                                    <td className="px-4 py-2">{(currentPage - 1) * pageSize + index + 1}</td>
                                    <td className="px-4 py-2">{item?.name}</td>
                                    <td className="px-4 py-2">{item?.email}</td>
                                    <td className="px-4 py-2">{moment(item?.createdAt).format('DD MMM YYYY')}</td>
                                    <td className='multi-select-box'>
                                        <Select
                                            isMulti
                                            options={gmailUsers}
                                            value={selectedEmailsByUser[item.id] || []}
                                            onChange={(val) => handleEmailChange(item.id, val)}
                                            placeholder="Select user"
                                            closeMenuOnSelect={true}       
                                            hideSelectedOptions={false}
                                        />

                                    </td>
                                    <td className="px-4 py-3 flex gap-2">

                                        <button
                                            className="table-icon-remove"
                                            onClick={() => {
                                                setShowModalDelete(true);
                                                setSelectDeleteId(item.id);
                                            }}
                                        >
                                            <MdDeleteOutline fontSize={20} />
                                        </button>
                                        <button
                                            className="table-icon-add"
                                            onClick={() =>
                                                navigate('/assignboard', {
                                                    state: item,
                                                })
                                            }
                                        >
                                            <MdAdd fontSize={20} />
                                        </button>
                                    </td>
                                    <td className="px-4 py-2">
                                        <div className="form-check form-switch flex items-center">
                                            <input
                                                className="form-check-input h-5 w-9 rounded-full border-gray-300 bg-gray-200 checked:bg-blue-500 focus:ring-blue-400"
                                                type="checkbox"
                                                checked={item.isPermission}
                                                onChange={() => handleArchivePermission(item)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-4">
                <div className="flex items-center gap-2">
                    <button
                        className="rounded-full border border-blue-400 text-blue-500 bg-white w-10 h-10 flex items-center justify-center shadow-sm hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        aria-label="Previous Page"
                    >
                        <MdChevronLeft size={28} />
                    </button>
                    <span className="font-medium text-base">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        className="rounded-full border border-blue-400 text-blue-500 bg-white w-10 h-10 flex items-center justify-center shadow-sm hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        aria-label="Next Page"
                    >
                        <MdChevronRight size={28} />
                    </button>
                </div>
            </div>
            {showModalDelete && (
                <DeleteModal
                    handleCloseModal={() => setShowModalDelete(false)}
                    handleConfirm={handleConfirm}
                    showModal={showModalDelete}
                    confirmButtonName="Delete"
                />
            )}
            {addUserStatus && (
                <AddUser
                    showModal={addUserStatus}
                    handleClose={() => setAddUserStatus(false)}
                    editData={editData}
                    GET_ALL_USER={GET_ALL_USER_DATA}
                    editId={editId}
                />
            )}
        </div>
    );
};

export default UserTable;
